import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from 'classes/ReducerBuilder';

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.SELECTED_HOMEPAGE_LAYOUT)
    .reduce((state, action) => {
      state.currentSelectedHomepageLayoutId = action.layoutId;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/EditHomepageLayoutsPage/reducer.js